<template>
  <div>
    <el-upload
      :class="{
        upload: true,
        mini: mini,
      }"
      action=""
      list-type="picture-card"
      :on-preview="handlePictureClick"
      :on-remove="handleRemove"
      :before-upload="handleBeforeUpload"
      :on-exceed="handleOnExceed"
      :limit="maxSize"
      :http-request="handleUpload"
      ref="uploadRef"
      :accept="imageTypeEnum.toString()"
    >
      <i class="el-icon-plus"></i>
      <div slot="tip" class="el-upload__tip" style="padding-top: 10px">
        只能上传{{ imageTypeEnum.join("/") }}文件，且不超过{{
          maxSize
        }}M，最多上传{{ maxSize }}张
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import api from "plus/api";

export default {
  name: "workOrderImageUpload",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    maxSize: {
      type: Number,
      default: 9,
    },
    mini: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageTypeEnum: [".jpg", ".jpeg", ".png"],
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  deactivated() {
    this.$refs.uploadRef.clearFiles();
  },
  methods: {
    handleRemove(file, fileList) {
      let newList = [...this.list].filter((item) => item.uid != file.uid);
      this.$emit("update:list", newList);
    },
    handlePictureClick(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleBeforeUpload(file) {
      const isImage = this.imageTypeEnum.some((item) =>
        file.name.endsWith(item)
      );
      if (!isImage) {
        this.$message.error("上传文件类型错误");
        return false;
      }
      const fileSize = this.checkFileSize(file);
      if (fileSize) {
        this.$message.error("文件大小超出限制");
        return false;
      }
      return true;
    },
    checkFileSize(file) {
      return file.size / 1024 > this.maxSize * 1024;
    },
    handleOnExceed(file, fileList) {
      this.$message.error(
        `当前限制选择 ${this.maxSize} 个文件，请删除后重新上传`
      );
    },
    async handleUpload(params) {
      try {
        const {
          data: {
            data: { token, fileName },
          },
        } = await api.qiniu.getToken({
          fileName: params.file.name,
        });
        const formData = new FormData();
        let index = params.file.name.lastIndexOf(".");
        let name = params.file.name.substr(index);
        formData.append("fileName", fileName);
        formData.append("file", params.file);
        formData.append("key", fileName + name);
        formData.append("token", token);
        const response = await api.qiniu.upload(formData);
        const newImage = {
          attachmentType: "IMAGE",
          appendisUrl: `https://cdn-workorder.meb.com/${response.data.key}`,
          uid: params.file.uid,
        };
        const newList = [...this.list, newImage];
        this.$emit("update:list", newList);
      } catch (error) {
        console.error("上传文件失败:", error);
        this.$message.error("上传文件失败，请稍后重试");
      }
    },
    clearData() {
      this.$refs.uploadRef.clearFiles();
    },
  },
};
</script>

<style lang="less">
.upload {
  margin-bottom: 20px;
}
.el-form-item__content .upload {
  line-height: 0 !important;
}

.mini .el-upload-list--picture-card .el-upload-list__item {
  width: 90px !important;
  height: 90px !important;
}
.mini .el-upload--picture-card {
  width: 90px !important;
  height: 90px !important;
  line-height: 110px !important;
}
.custom-image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.custom-image-item {
  position: relative;
  width: 100px;
  height: 100px;
}

.custom-image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.custom-image-item .el-icon-delete {
  position: absolute;
  top: 5px;
  right: 5px;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 2px;
  cursor: pointer;
}
</style>
